import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "grid grid-cols-2 gap-4 grid-rows-1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_IconThumbUpOutline = _resolveComponent("IconThumbUpOutline")!
  const _component_IconThumbDownOutline = _resolveComponent("IconThumbDownOutline")!
  const _component_ListComponent = _resolveComponent("ListComponent")!
  const _component_PaginatorComponent = _resolveComponent("PaginatorComponent")!
  const _component_IconClose = _resolveComponent("IconClose")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_LoaderComponent, null, null, 512), [
      [_vShow, _ctx.state.loaderGet]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ListComponent, {
        title: "список постов",
        list: _ctx.list.general,
        onEmitId: _cache[0] || (_cache[0] = (value)=>_ctx.postMoveList(value))
      }, {
        buttons: _withCtx(({ events: {upId} }) => [
          _createElementVNode("button", {
            class: "bg-blue-400 p-1 text-white rounded mx-3",
            onClick: ($event: any) => (upId(_ctx.StatusEnum.LIKE))
          }, [
            _createVNode(_component_IconThumbUpOutline)
          ], 8, _hoisted_2),
          _createElementVNode("button", {
            class: "bg-red-500 p-1 text-white rounded",
            onClick: ($event: any) => (upId(_ctx.StatusEnum.DISLIKE))
          }, [
            _createVNode(_component_IconThumbDownOutline)
          ], 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["list"]),
      _createVNode(_component_PaginatorComponent, {
        length: _ctx.state.listGeneralLength,
        onEmitActiveIndex: _cache[1] || (_cache[1] = (value)=> _ctx.pagination(value))
      }, null, 8, ["length"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ListComponent, {
          title: "нравится",
          "title-style": "text-blue-600",
          "shadow-style": "c-shadow-blue-1",
          list: _ctx.list.like,
          onEmitId: _cache[2] || (_cache[2] = (value)=>_ctx.postMoveList(value))
        }, {
          buttons: _withCtx(({ events: {upId} }) => [
            _createElementVNode("button", {
              class: "bg-red-500 p-1 text-white rounded ms-2",
              onClick: ($event: any) => (upId(_ctx.StatusEnum.GENERAL))
            }, [
              _createVNode(_component_IconClose, { size: "16px" })
            ], 8, _hoisted_5)
          ]),
          _: 1
        }, 8, ["list"]),
        _createVNode(_component_ListComponent, {
          title: "не нравится",
          "title-style": "text-red-600",
          "shadow-style": "c-shadow-red-1",
          list: _ctx.list.dislike,
          onEmitId: _cache[3] || (_cache[3] = (value)=>_ctx.postMoveList(value))
        }, {
          buttons: _withCtx(({ events: {upId} }) => [
            _createElementVNode("button", {
              class: "bg-red-500 p-1 text-white rounded ms-2",
              onClick: ($event: any) => (upId(_ctx.StatusEnum.GENERAL))
            }, [
              _createVNode(_component_IconClose, { size: "16px" })
            ], 8, _hoisted_6)
          ]),
          _: 1
        }, 8, ["list"])
      ])
    ])
  ]))
}